import Axios from "axios";
import { getSignedS3UrlApi } from "../services/newServices";
import { v4 as uuid } from "uuid";
import storageService from "../services/storageServices";

export const otaList = [
  "hotelzify.com",
  "www.makemytrip.com",
  "d.adx.io",
  "www.trivago.in",
  "www.trip.com",
  "hotel.easemytrip.com",
  "hotel.yatra.com",
  "www.goibibo.com",
  "www.agoda.com",
  "www.booking.com",
  "www.tripadvisor.in",
  "www.priceline.com",
  "mytravaly.com",
  "www.skyscanner.net",
  "zenhotels.com",
  "in.hotels.com",
  "lastminute.com",
  "kayak.co.in",
  "reservationlodge.com",
  "www.bluepillow.in",
  "traveluro.com",
  "www.hostelworld.com",
  "www.expedia.co.in",
  "www.wotif.com",
  "www.ebookers.ie",
  "www.orbitz.com",
  "www.travelocity.com",
];

export function convert24hrTo12hr(time24hr = "00:00:00") {
  const splitTime = time24hr.split(":");
  let period = "AM";

  let hours12 = parseInt(splitTime[0], 10);

  if (hours12 >= 12) {
    period = "PM";

    if (hours12 >= 24) {
      hours12 = 0;
      period = "AM";
    } else if (hours12 > 12) {
      hours12 -= 12;
    }
  }
  if (hours12 === 0) {
    hours12 = 12;
  }

  return `${hours12.toString().padStart(2, "0")}:${splitTime[1]} ${period}`;
}

export const removeSpecialCharacters = (str) => {
  // Use a regular expression to match all special characters and replace them with spaces
  return str?.replace(/[^\w\s]/gi, " ");
};

export function hasSpecialCharacters(text) {
  var specialCharacters = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

  for (var i = 0; i < text.length; i++) {
    if (specialCharacters.test(text[i])) {
      return true;
    }
  }
  return false;
}

export const removeObjectsWithNullValues = (arr) => {
  return arr.filter((obj) => {
    for (const key in obj) {
      if (obj[key] === null) {
        return false;
      }
    }
    return true;
  });
};

export const removeObjectWithNullValues = (obj) => {
  if (!obj || typeof obj !== "object") {
    return {}; // Return an empty object or handle the error appropriately
  }

  const newObj = {};
  for (const key in obj) {
    if (obj[key] !== null && obj[key] !== "") {
      newObj[key] = obj[key];
    }
  }
  return newObj;
};

export async function urlsToFiles(urlArray) {
  const filePromises = urlArray.map(async (url, index) => {
    const response = await fetch(url);
    const blob = await response.blob();
    const filename = `downloaded_file_${index}`;
    return new File([blob], filename);
  });

  return Promise.all(filePromises);
}

export function compareURLArrays(array1, array2) {
  const set1 = new Set(array1);
  const set2 = new Set(array2);

  // Convert sets back to arrays to compare order
  const newArray1 = [...set1];
  const newArray2 = [...set2];

  if (newArray1.length !== newArray2.length) {
    return true;
  }

  for (let i = 0; i < newArray1.length; i++) {
    if (newArray1[i] !== newArray2[i]) {
      return true;
    }
  }

  return false;
}

export function areAllEmailsValid(emailArray) {
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailArray.every((email) => emailRegex.test(email));
}
export function isEmailValid(email) {
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(email);
}
export function isPhoneNumberValid(phoneNumber) {
  const phoneRegex = /^\+?[1-9]\d{1,14}$/;
  return phoneRegex.test(phoneNumber);
}

export const gmbIcons = {
  "hotelzify.com": {
    name: "hotelzify",
    logo: "https://www.gstatic.com/travel-hotels/branding/b348e7c3-504b-4289-8ff0-3ae26124d2e7.png",
  },
  "www.makemytrip.com": {
    name: "makemytrip",
    logo: "https://www.gstatic.com/travel-hotels/branding/icon_116.png",
  },
  "d.adx.io": {
    name: "Clear Trip",
    logo: "https://www.gstatic.com/travel-hotels/branding/icon_116.png",
  },
  "www.trivago.in": {
    name: "Trivago",
    logo: "https://www.gstatic.com/travel-hotels/branding/icon_116.png",
  },
  "www.trip.com": {
    name: "Trip.com",
    logo: "https://www.gstatic.com/travel-hotels/branding/icon_116.png",
  },
  "hotel.easemytrip.com": {
    name: "Ease My Trip",
    logo: "https://www.gstatic.com/travel-hotels/branding/icon_116.png",
  },
  "hotel.yatra.com": {
    name: "Yatra",
    logo: "https://www.gstatic.com/travel-hotels/branding/icon_101347500.png",
  },
  "www.goibibo.com": {
    name: "Goibibo",
    logo: "https://www.gstatic.com/travel-hotels/branding/icon_161.png",
  },
  "www.agoda.com": {
    name: "Agoda",
    logo: "https://www.gstatic.com/travel-hotels/branding/b13642de-d476-41bd-8254-3edc2e567aa6.png",
  },
  "www.booking.com": {
    name: "booking",
    logo: "https://www.gstatic.com/travel-hotels/branding/0db7b410-170b-414a-a1d7-453125a74f54.png",
  },
  "www.tripadvisor.in": {
    name: "Tripadvisor",
    logo: "https://www.gstatic.com/travel-hotels/branding/6dcb5a28-6742-4ce4-9beb-07c31138a20b.png",
  },
  "www.priceline.com": {
    name: "Priceline",
    logo: "https://www.gstatic.com/travel-hotels/branding/icon_220.png",
  },
  "mytravaly.com": {
    name: "mytravaly",
    logo: "https://www.gstatic.com/travel-hotels/branding/8fbc332c-af5e-4639-94f8-d7230a951ef9.png",
  },
  "www.skyscanner.net": {
    name: "Sky Scanner",
    logo: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAA/5JREFUWIXtl2toHFUUx393ZnYn+8puN2mIpN20IkoTHxQRW6tUxDfUF01NLYrg46O2UBQUoSAKtUa/iFYKGsQHtNp8ENKAkYK0CEKg1PhJEMnD2iZNMpvs487OzPXD3cRsdjfWVIgfcmDZhZ177u+c8z/n3hH2/lHFKpqxmpuvAawB/C8ArJUudBWoqQAAkTYIi5X5uaIMSB/knEIGizY3BblPMsjeDMoQuOVpIoPys/5/BCB9eHSDxdkDTdyWMpABKAWEBbYJpgBsgVJ689ubTM7sb2JXm3VFEMsCKICi4lBXijs6ovR0rwMn+Pt/VYaZt5mAd3en2NEZ5VBXCqTin8bssgACIAwfDmQBuGtLhHu2hMGr4bak2LPV5s6OCABHBxwIlX38WwDpg8zrmtshwbGfivwwnAfg0+eaYU4DCKE/ehG81Z0GYPBcjmNDLuGQ0Joo1NdEFYD0YU+7Rf/z6yAskAUFCYOdn0/j+pBptnjviTg4AbKkKLoKJn3e3xXnutYQRU9x4KQDMYGbVzRFBSeeTvF4prYmKtpQAUjFm91prm8Lk7slxkf90xz8NgfZgN7vHV68P0ksYkJJ0d3z50I1ojEdyxenHYZHPBCCnsfivPBAkkSDwQ0bQvS9PYGKioqyiKXHsfQUL21t4PXdaVoaTQDGpzxe+/Iyn513eTBjMnApwDTB9wEBlgGeD/euNxgc89nbaXP4qTQbm3V8Fx2fI31T9AwVsa1KVVQBAMiSginF0Wcaefa+FLYJOQ/ir46DqzCt6gnmA54H2IL84TYipi7nx6emefnrOYiBXWNa1QSYL4ebU5AyGNyX4mLWZ9/xLMJc1Hrz32W/QoDy4KsnkySjgoePOzATEIqKuu1WF0AG6HaTQDaAAIgbEBMQN8hEBZGy10IAI3kF+UDPiYLS8k4YYAOWwK5DUHUWyFkFUkGLyRvbImzbHKYxZZFZH6I1aepgBQghFlpQDyQdhwrgD8dnfLJE1vE4/avkyHkXecEDW2AnltGAnFX8+EoznZsaSCyplwL8QAtuOfNVeTwvsVlX8cvvRba/M1kBUZkBV3HztREsobg04/HzqMtvYy6jEyX6x3yGZgM+2BFh792NpONmxdLLcz693zkcHCpya9TgoTaTza0h2q8Jc9PGMKmkRUd7A5QUi+djZQZ86M5YjBYUZ0c8HXYIXU9T6HVFBVHBN11JHtmewBBw8kyWrr5ZyAVgi3K6lNZNSfveucmixYQTF3zsRezVc6Dc2yGj/kEhA6CguLHZwBJwbiKASH2hKcAN9A+7MnHVIlz6QC2zDSAmGM5pdju2/JEj5tfUsBXfiBZArtJW/U64BrAGcFVdMG9K3z1X9GbwF+Fek+cry8TmAAAAAElFTkSuQmCC",
  },
  "zenhotels.com": {
    name: "zenhotels",
    logo: "https://www.gstatic.com/travel-hotels/branding/0f028fed-dba3-4f7e-98c4-93b7ac1eebca.png",
  },
  "in.hotels.com": {
    name: "hotels",
    logo: "https://www.gstatic.com/travel-hotels/branding/1bf6ef2c-9c95-4ddd-ae11-bc9bdf419004.png",
  },
  "lastminute.com": {
    name: "lastminute",
    logo: "https://www.gstatic.com/travel-hotels/branding/97cf11a1-4aa0-4d03-9e9d-0ad955d07386.png",
  },
  "kayak.co.in": {
    name: "kayak.co.in",
    logo: "https://www.gstatic.com/travel-hotels/branding/icon_100979605.png",
  },
  "reservationlodge.com": {
    name: "reservation lodge",
    logo: "https://www.gstatic.com/travel-hotels/branding/icon_100979605.png",
  },
  "www.bluepillow.in": {
    name: "Blue Pillow",
    logo: "https://www.gstatic.com/travel-hotels/branding/c770e909-af04-45dd-8ad7-335bc5055826.png",
  },
  "traveluro.com": {
    name: "traveluro",
    logo: "https://www.gstatic.com/travel-hotels/branding/aa5293d0-1acc-4289-ab28-fe6381cfbe5a.png",
  },
  "www.hostelworld.com": {
    name: "Hostel world",
    logo: "//https://www.gstatic.com/travel-hotels/branding/icon_100372930.png",
  },
  "www.expedia.co.in": {
    name: "Expedia.co.in",
    logo: "https://https://www.gstatic.com/travel-hotels/branding/ac238c97-1652-4830-8da8-bb8d8883af88.png",
  },
  "www.wotif.com": {
    name: "Wotif.com",
    logo: "https://https://www.gstatic.com/travel-hotels/branding/icon_100325604.png",
  },
  "www.ebookers.ie": {
    name: "ebookers.ie",
    logo: "https://https://www.gstatic.com/travel-hotels/branding/1af2ba27-a943-48b6-822c-864c167aaaa1_%5BUngrouped%5D.png",
  },
  "www.orbitz.com": {
    name: "Orbitz.com",
    logo: "https://https://www.gstatic.com/travel-hotels/branding/icon_100640403.png",
  },
  "www.travelocity.com": {
    name: "Travelocity.com",
    logo: "https://https://www.gstatic.com/travel-hotels/branding/icon_185.png",
  },
};

export const progressImages = {
  12.5: "https://ik.imagekit.io/hotelzifyprod/progressbar/12.5__iwqQ360mL.svg?updatedAt=1693388907309",
  25: "https://ik.imagekit.io/hotelzifyprod/progressbar/25_JuwaJ7ZoLS.svg?updatedAt=1693388907334",
  37.5: "https://ik.imagekit.io/hotelzifyprod/progressbar/37.5_vj7M6YIElO.svg?updatedAt=1693388907297",
  50: "https://ik.imagekit.io/hotelzifyprod/progressbar/50_b-EMLxSg2J.svg?updatedAt=1693388907376",
  62.5: "https://ik.imagekit.io/hotelzifyprod/progressbar/62.5_lpVjWa1_o.svg?updatedAt=1693388907340",
  75: "https://ik.imagekit.io/hotelzifyprod/progressbar/75_6gZsGX0AIO.svg?updatedAt=1693388907487",
  87.5: "https://ik.imagekit.io/hotelzifyprod/progressbar/87.5_897QetCMXv.svg?updatedAt=1693388907324",
  100: "https://ik.imagekit.io/hotelzifyprod/progressbar/100_78d28cxx7.svg?updatedAt=1693388907326",
};

export const uploadImagesToS3 = async (images) => {
  const signedUrlPromises = [];
  const fileNames = [];
  images.forEach((image) => {
    const fileTypeSplit = image?.name?.includes("place-images")
      ? ["jpg"]
      : image?.name?.split(".") ?? ["png"];

    const fileType = fileTypeSplit[fileTypeSplit.length - 1];
    const fileName = `${fileTypeSplit?.[0]}_${uuid()}.${fileType}`.replace(
      /\s+/g,
      ""
    );
    fileNames.push(fileName);
    signedUrlPromises.push(getSignedS3UrlApi(fileName));
  });
  const signedUrls = await Promise.all(signedUrlPromises);

  const uploadFiles = signedUrls.map((url, i) => {
    return Axios.put(url?.data?.url, images[i]);
  });
  const responseData = await Promise.all(uploadFiles);
  return {
    status: responseData?.[0]?.status,
    data: fileNames.map(
      (name) => `${process.env.REACT_APP_S3_BUCKET_URL}/${name}`
    ),
    names: fileNames.map(
      (name) => `${process.env.REACT_APP_S3_BUCKET_URL}/${name}`
    ),
  };
};

export const uploadVideosToS3 = async (videos) => {
  const signedVideoUrlPromises = [];
  const vdfileNames = [];
  videos.forEach((vd) => {
    const vdfileTypeSplit = vd?.name?.includes("place-images")
      ? ["mp4"]
      : vd?.name?.split(".") ?? ["mp4"];

    const vdfileType = vdfileTypeSplit[vdfileTypeSplit.length - 1];
    const vdfileName = `${
      vdfileTypeSplit?.[0]
    }_${uuid()}.${vdfileType}`.replace(/\s+/g, "");

    vdfileNames.push(vdfileName);
    signedVideoUrlPromises.push(getSignedS3UrlApi(vdfileName));
  });

  const signedVideoUrls = await Promise.all(signedVideoUrlPromises);
  const uploadFiles = signedVideoUrls?.map((url, i) => {
    return Axios.put(url?.data?.url, videos[i]);
  });
  const responseVideoData = await Promise.all(uploadFiles);
  return {
    status: responseVideoData?.[0]?.status,
    data: vdfileNames.map(
      (name) => `${process.env.REACT_APP_S3_BUCKET_URL}/${name}`
    ),
    names: vdfileNames.map(
      (name) => `${process.env.REACT_APP_S3_BUCKET_URL}/${name}`
    ),
  };
};

export const camelCaseToNormal = (text) => {
  let res = "";
  for (let char of text) {
    if (char === char.toUpperCase()) {
      res += ` ${char.toLowerCase()}`;
    } else if (char === "-") {
      res += " ";
    } else {
      res += char;
    }
  }
  return res;
};

export const isAdmin = () => {
  const userDetails = storageService.get("userAdmin");
  const isAdmin = userDetails?.role === "ADMIN";
  return isAdmin;
};

export const removeURLParameter = (parameterName) => {
  var url = window.location.href;
  var regex = new RegExp("[?&]" + parameterName + "=[^&]*");
  var newURL = url.replace(regex, "");
  newURL = newURL.replace(/&$/, "").replace(/\?$/, "");
  window.history.replaceState({}, "", newURL);
};

export function convertTo24Hour(timeString) {
  // Check if the input is in 12-hour format (contains 'AM' or 'PM')
  const is12HourFormat =
    timeString.indexOf("AM") > -1 || timeString.indexOf("PM") > -1;

  // Extract hours, minutes, and AM/PM if present
  const [timePart, ampmPart] = timeString.split(" ");
  const [hours, minutes] = timePart
    .split(":")
    .map((part) => parseInt(part, 10));

  let convertedHours = hours;

  if (is12HourFormat) {
    // Convert 12-hour format to 24-hour format
    if (hours === 12 && ampmPart === "AM") {
      convertedHours = 0;
    } else if (hours < 12 && ampmPart === "PM") {
      convertedHours += 12;
    }
  }

  // Format the hours and minutes to ensure leading zeros if necessary
  const formattedHours =
    convertedHours < 10 ? `0${convertedHours}` : convertedHours;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  // Return the time in 24-hour format
  return `${formattedHours}:${formattedMinutes}`;
}

const exceptThisSymbols = ["e", "E", "+", "-", "."];

export const filterNumberInput = (e) => {
  if (exceptThisSymbols.includes(e.key)) {
    e.preventDefault();
  }
};

export const distanceCalculation = (lat1, lon1, lat2, lon2, isMI = false) => {
  const R = 6371; // Radius of the Earth in kilometers
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) *
      Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  let distance = R * c; // Distance in kilometers

  if (isMI) {
    distance *= 0.621371;
  }

  return distance?.toFixed(2);
};

// distanceUtils.js
export const convertDistance = (distance, fromMetric, toMetric) => {
  if (fromMetric === toMetric) return distance;

  if (fromMetric === "km" && toMetric === "mi") {
    return (distance * 0.621371).toFixed(2);
  } else if (fromMetric === "mi" && toMetric === "km") {
    return (distance / 0.621371).toFixed(2);
  } else if (fromMetric === "m" && toMetric === "km") {
    return (distance / 1000).toFixed(2);
  } else if (fromMetric === "m" && toMetric === "mi") {
    return (distance / 1609.34).toFixed(2);
  }

  return distance;
};
